var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComunicados = function SvgComunicados(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "comunicados_svg__Capa_2",
    viewBox: "0 0 65.97 57.76"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comunicados_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.14 0H9.82C4.4 0 0 4.4 0 9.82v26.86c0 5.42 4.4 9.82 9.82 9.82v8.88c0 1.99 2.3 3.09 3.85 1.85l14.74-10.74h27.72c5.43 0 9.83-4.4 9.83-9.83V9.83c0-5.43-4.4-9.83-9.83-9.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.77,
    height: 4.45,
    x: 10.27,
    y: 8.9,
    rx: 2.23,
    ry: 2.23,
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.82,
    height: 4.45,
    x: 10.27,
    y: 19.97,
    rx: 2.23,
    ry: 2.23,
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.82,
    height: 4.45,
    x: 10.27,
    y: 31.74,
    rx: 2.23,
    ry: 2.23,
    fill: "#500d76"
  }))));
};
export default SvgComunicados;